export default "__VITE_ASSET__ckmvtGbM__"